import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row, Card, Button } from 'reactstrap'
import { Column, Table } from 'react-virtualized';
import AutoSizer from 'react-virtualized-auto-sizer';
import Title from '../../../../sharedComponents/Title/Title';
import ItemScoreOverviewChart from './ItemScoreCharts/ItemScoreOverviewChart';
import { slideDrawer } from '../../../../reducers/UIReducer/UIActions';
import { setDashboardDrawerContents } from '../../../../reducers/DashboardReducer/DashboardActions';
import formatters from '../../../../config/formatters';

const ItemScoreOverview = (props) => {
    const { numberFormatter } = formatters();
    const dispatch = useDispatch();
    const selectedCategory = props.selectedCategory;
    const overviewData = props.overviewData;
    const [top5TableData, setTop5TableData] = useState([]);
    const [bottom5TableData, setBottom5TableData] = useState([]);
    const [competitorProductsSorted, setCompetitorProductsSorted] = useState([]);

    const top5ItemsTable = (
        <Row className='mx-0' style={{height: '92vh', width: '100%'}}>
            <Col className='p-0 m-0' style={{height: '100%', width: '99%'}}>
                <AutoSizer>
                    {({width, height}) => (
                        <Table className="table top5ItemScoreTable border-grayLight" id="top5ItemScoreTableSlideDrawer"
                            width={width}
                            height={height}
                            headerHeight={34.5}
                            rowHeight={38}
                            rowCount={top5TableData?.length}
                            rowGetter={({ index }) => top5TableData[index]}
                        >
                            <Column
                            label='Score'
                            dataKey='item_score'
                            width={width * 0.1}
                            cellRenderer={({cellData}) => <span style={{fontWeight: 'bold'}}>{cellData}</span>}
                            />
                            <Column
                            width={width * 0.1}
                            label='MIN'
                            dataKey='product_id'
                            />
                            <Column
                            width={width * 0.15}
                            label='Brand'
                            dataKey='brand'
                            />
                            <Column
                            width={width * 0.35}
                            label='Description'
                            dataKey='description'
                            />
                            <Column
                            width={width * 0.15}
                            label='Pack Size'
                            dataKey='pack_size'
                            />
                            <Column 
                            width={width * 0.125}
                            label='Days Purchased'
                            dataKey='days_purchased'
                            cellRenderer={({cellData}) => <span>{numberFormatter.format(cellData)}</span>}
                            />
                            <Column
                            width={width * 0.125}
                            label='Invoices'
                            dataKey='total_invoices'
                            cellRenderer={({cellData}) => <span>{numberFormatter.format(cellData)}</span>}
                            />
                        </Table>
                    )}
                </AutoSizer>
            </Col>
        </Row>
    );

    const handleClickTop5ShowMore = () => {
        dispatch(setDashboardDrawerContents('Item Performance List', top5ItemsTable));
        dispatch(slideDrawer.add());
    }

    const handleClickViewInsight = (selectedItem) => {
        props.handleViewInsights(selectedItem);
    }

    useEffect(() => {
        if (overviewData) {
            const topData = overviewData?.ownProducts?.toSorted((a,b) => b.item_score - a.item_score) ?? [];
            const bottomData = overviewData?.ownProducts?.toSorted((a,b) => a.item_score - b.item_score) ?? [];
            const competitorData = overviewData?.competitorProducts?.toSorted((a,b) => b.item_score - a.item_score) ?? [];
            setTop5TableData(topData);
            setBottom5TableData(bottomData);
            setCompetitorProductsSorted(competitorData);
        }
    }, [overviewData])

    return (
       <Col className='py-3 pt-0'>
            <Card className='p-3'>
                <Row className='mx-1'>
                    <Col className='px-0'>
                        <Row className='my-2'>
                            <div className='main-header text-size-24 pb-2' style={{fontWeight: '700', letterSpacing:'.0025em', lineHeight: '24px'}}>
                                Trend Score Highlights
                            </div>
                        </Row>
                        <Row>
                            <ItemScoreOverviewChart overviewData={overviewData} top5Data={top5TableData} bottom5Data={bottom5TableData} competitorData={competitorProductsSorted}/>
                        </Row>
                        <Row>
                            <Col className='col-4'>
                                <Row>
                                    <Col className='w-fc pt-1 px-1'>
                                        <div style={{ height: '16px', width: '16px', backgroundColor: '#C10D0D'}}></div>
                                    </Col>
                                    <Col className='w-fc ps-0 pe-1' style={{fontWeight: '700'}}>Your Bottom Item: </Col>
                                    <Col className='w-fc p-0' style={{textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', overflow: 'hidden'}} title={bottom5TableData ? bottom5TableData[0]?.description : ''}>{bottom5TableData ? bottom5TableData[0]?.description : ''}</Col>
                                    <Col className='w-fc ps-1' style={{fontWeight: '700'}}> &#40;{bottom5TableData ? bottom5TableData[0]?.item_score : ''}&#41;</Col>
                                </Row>
                                <Row>
                                    <Col className='w-fc pt-1 px-1'>
                                        <div style={{ height: '16px', width: '16px', backgroundColor: '#FF7A00'}}></div>
                                    </Col>
                                    <Col className='w-fc ps-0 pe-1' style={{fontWeight: '700'}}>Overall Bottom Item: </Col>
                                    <Col className='w-fc p-0' style={{textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', overflow: 'hidden'}} title={competitorProductsSorted ? competitorProductsSorted[competitorProductsSorted?.length - 1]?.description : ''}>{competitorProductsSorted ? competitorProductsSorted[competitorProductsSorted?.length - 1]?.description : ''}</Col>
                                    <Col className='w-fc ps-1' style={{fontWeight: '700'}}> &#40;{competitorProductsSorted ? competitorProductsSorted[competitorProductsSorted?.length - 1]?.item_score : ''}&#41;</Col>
                                </Row>
                            </Col>
                            <Col className='col-4'>
                                <Row>
                                    <Col className='w-fc pe-1 pt-1'>
                                        <div style={{ height: '16px', width: '16px', backgroundColor: '#0B9402'}}></div>
                                    </Col>
                                    <Col className='px-1'>
                                        <span style={{fontWeight: '700'}}>Your {selectedCategory?.label} Avg </span>
                                        <span style={{fontWeight: '700'}}> &#40;{overviewData?.ownAverage}&#41;</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='w-fc pe-1 pt-1'>
                                        <div style={{ height: '16px', width: '16px', backgroundColor: '#0B4807'}}></div>
                                    </Col>
                                    <Col className='px-1'>
                                        <span style={{fontWeight: '700'}}>{selectedCategory?.label} Category Avg</span>
                                        <span style={{fontWeight: '700'}}> &#40;{overviewData?.overallAverage}&#41;</span>
                                    </Col>
                                </Row>
                            </Col>
                            <Col className='col-4'>
                                <Row>
                                    <Col className='w-fc pt-1 px-1'>
                                        <div style={{ height: '16px', width: '16px', backgroundColor: '#49A4DA'}}></div>
                                    </Col>
                                    <Col className='w-fc ps-0 pe-1' style={{fontWeight: '700'}}>Your Top Item: </Col>
                                    <Col className='w-fc p-0' style={{textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', overflow: 'hidden'}} title={top5TableData ? top5TableData[0]?.description : ''}>{top5TableData ? top5TableData[0]?.description : ''}</Col>
                                    <Col className='w-fc ps-1' style={{fontWeight: '700'}}> &#40;{top5TableData ? top5TableData[0]?.item_score : ''}&#41;</Col>
                                </Row>
                                <Row>
                                    <Col className='w-fc pt-1 px-1'>
                                        <div style={{ height: '16px', width: '16px', backgroundColor: '#006099'}}></div>
                                    </Col>
                                    <Col className='w-fc ps-0 pe-1' style={{fontWeight: '700'}}>Overall Top Item: </Col>
                                    <Col className='w-fc p-0' style={{textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', overflow: 'hidden'}} title={competitorProductsSorted ? competitorProductsSorted[0]?.description : ''}>{competitorProductsSorted ? competitorProductsSorted[0]?.description : ''}</Col>
                                    <Col className='w-fc ps-1' style={{fontWeight: '700'}}> &#40;{competitorProductsSorted ? competitorProductsSorted[0]?.item_score : ''}&#41;</Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
            <Card className='px-3 pb-3'>
                <Row className='mx-1'>
                    <Col>
                        <Row>
                            <Title title='Item Performance List' />
                        </Row>
                        <Row style={{borderLeft: '1px lightgray solid', borderRight: '1px lightgray solid', borderTop: '1px lightgray solid', borderRadius: '8px 8px 0px 0px'}}>
                            <Col className='p-0 m-0' style={{height: '420px', width: '99%'}}>
                                <AutoSizer>
                                    {({width, height}) => (
                                        <Table className="table top5ItemScoreTable border-grayLight" id="top5ItemScoreTable"
                                            width={width}
                                            height={height}
                                            headerHeight={34.5}
                                            rowHeight={38}
                                            rowCount={top5TableData?.length < 10 ? top5TableData?.length : 10}
                                            rowGetter={({ index }) => top5TableData[index]}
                                        >
                                            <Column
                                            label='Score'
                                            dataKey='item_score'
                                            minWidth={54}
                                            width={width * 0.075}
                                            cellRenderer={({cellData}) => <span style={{fontWeight: 'bold'}}>{cellData}</span>}
                                            />
                                            <Column
                                            minWidth={75}
                                            width={width * 0.1}
                                            label='MIN'
                                            dataKey='product_id'
                                            />
                                            <Column
                                            minWidth={90}
                                            width={width * 0.125}
                                            label='Brand'
                                            dataKey='brand'
                                            />
                                            <Column
                                            minWidth={100}
                                            width={width * 0.35}
                                            label='Description'
                                            dataKey='description'
                                            />
                                            <Column
                                            minWidth={75}
                                            width={width * 0.1}
                                            label='Pack Size'
                                            dataKey='pack_size'
                                            />
                                            <Column 
                                            minWidth={130}
                                            width={width * 0.125}
                                            label='Days Purchased'
                                            dataKey='days_purchased'
                                            cellRenderer={({cellData}) => <span>{numberFormatter.format(cellData)}</span>}
                                            />
                                            <Column
                                            minWidth={70}
                                            width={width * 0.1}
                                            label='Invoices'
                                            dataKey='total_invoices'
                                            cellRenderer={({cellData}) => <span>{numberFormatter.format(cellData)}</span>}
                                            />
                                            <Column 
                                            minWidth={100}
                                            label=''
                                            dataKey='total_invoices'
                                            cellRenderer={({rowData}) => <Button className='py-1 button-label' style={{color: 'white', width: '100%', textAlign: 'center'}} size='sm' color={'blueFilter'} onClick={() => handleClickViewInsight(rowData)}>View Insights</Button>}
                                            />
                                        </Table>
                                    )}
                                </AutoSizer>
                            </Col>
                        </Row>
                        <Row className='px-2' style={{justifyContent: 'center', borderBottom: '1px lightgray solid', borderLeft: '1px lightgray solid', borderRight: '1px lightgray solid', borderRadius: '0px 0px 8px 8px', cursor: 'pointer'}} onClick={() => handleClickTop5ShowMore()}>
                            {top5TableData?.length > 10 &&
                            <Col className='w-fc py-2'>
                                <div className='text-size-16' style={{color: '#00A0FF', fontWeight: 'bold'}}>Show More...</div>
                            </Col>
                            }
                        </Row>
                    </Col>
                </Row>
            </Card>
       </Col>
    )
}

export default ItemScoreOverview